import React from 'react';
import { Box, Typography } from '@mui/material';
import { TypingUser } from '../../types/chat.types';

interface TypingIndicatorProps {
  users: TypingUser[];
}

export const TypingIndicator = function TypingIndicator({
  users
}: TypingIndicatorProps) {
  console.log('🔵 TypingIndicator rendering, users:', users);
  if (users.length === 0) return null;

  const names = users.map((u) => u.userName).join(', ');
  const verb = users.length === 1 ? 'is' : 'are';

  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'surface.100',
        borderRadius: 2,
        display: 'flex',
        gap: 1,
        mb: 2, // FIXED: Enough margin to be visible above sticky footer
        ml: 6, // Indent to align with messages (account for avatar space)
        p: 1.5,
        width: 'fit-content'
      }}
    >
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {[0, 150, 300].map((delay) => (
          <Box
            key={delay}
            sx={{
              '@keyframes bounce': {
                '0%, 80%, 100%': {
                  transform: 'scale(0)'
                },
                '40%': {
                  transform: 'scale(1)'
                }
              },
              animation: 'bounce 1.4s infinite ease-in-out',
              animationDelay: `${delay}ms`,
              bgcolor: 'secondary.400',
              borderRadius: '50%',
              height: 8,
              width: 8
            }}
          />
        ))}
      </Box>
      <Typography color="secondary.600" variant="body_200">
        <Box component="span" sx={{ fontWeight: 600 }}>
          {names}
        </Box>{' '}
        {verb} typing...
      </Typography>
    </Box>
  );
};

export default TypingIndicator;
